<template>
<div class="legal-page page-template-default page separate-containers no-sidebar nav-below-header header-aligned-left dropdown-hover">
  <HeadNav :page="navPage" />
  <GuideBreadcrumb :items="page.breadcrumb" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="legal-shell">
            <header class="entry-header">
              <h1 class="entry-title">{{ page.title }}</h1>
              <p v-if="page.effectiveDate" class="article-meta">
                <strong>Effective date:</strong> {{ page.effectiveDate }}
              </p>
            </header>
            <div class="article-body">
              <section v-for="(sec, i) in page.sections" :key="i" class="legal-section">
                <h2 v-if="sec.h2" class="legal-section__h">{{ sec.h2 }}</h2>
                <p v-for="(p, pi) in sec.paragraphs || []" :key="'p' + pi" v-html="p" />
                <p v-if="sec.email">
                  <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a>
                </p>
                <ul v-if="sec.list" class="legal-section__list">
                  <li v-for="(item, li) in sec.list" :key="li" v-html="item" />
                </ul>
              </section>
              <nav
                v-if="page.relatedNav && page.relatedNav.length"
                class="legal-related-nav"
                aria-label="Related site pages"
              >
                <a
                  v-for="(link, ri) in page.relatedNav"
                  :key="link.href"
                  :href="link.href"
                >{{ link.label }}</a>
              </nav>
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/guide-pages.scss'
import '@/css/legal-page.scss'
import HeadNav from '@/components/HeadNav.vue'
import GuideBreadcrumb from '@/components/GuideBreadcrumb.vue'
import { SUPPORT_EMAIL } from '@/config/site'

export default {
  name: 'LegalSiteArticle',
  components: { HeadNav, GuideBreadcrumb },
  props: {
    page: { type: Object, required: true },
    navPage: { type: String, default: 'home' },
  },
  data() {
    return { supportEmail: SUPPORT_EMAIL }
  },
}
</script>
